import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Container from 'react-bootstrap/Container';
import Button from "react-bootstrap/Button";
import { BackTextLink } from "../../components/UI/TextLink/TextLink";
import classes from './AppointmentManagement.css';

import axios from 'axios';
import Alert from 'react-s-alert';
import { backendEndpoint, beautifyLocalTimeFromTimestamp } from '../../store/utility';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons';


class AppointmentManagement extends React.Component{

    constructor(props){
        super(props);
        this.messageInput = React.createRef(); 
        this.state = {
            host_name: '',
            guest_name: '',
            time: '',
            messages: []
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        if (this.props.authToken !== null){
            this.loadAppointment();
            this.loadMessages();
        }
        else {
            // in case of a refresh page, wait for 100 ms until authToken retrieved
            setTimeout(()=> { 
                this.loadAppointment();
                this.loadMessages();
            }, 100);
        }
    }

    loadAppointment = () => {
        let url = backendEndpoint + 'appointment/' + this.props.match.params.appointment_id + '/';
        axios.get(url, {
            headers: {'Authorization': 'Token '+ this.props.authToken}
            })
            .then(response => {
                // response.data.
                this.setState({
                    guest_name: response.data.first_name + ' ' + response.data.last_name,
                    host_name: response.data.host.first_name + ' ' + response.data.host.last_name,
                    time: beautifyLocalTimeFromTimestamp(response.data.due_date),
                    details: response.data.info,
                    role: response.data.role,
                    contact_method: response.data.contact_method,
                });
            })
            .catch(err => {
                Alert.error('failed to load appointment');
            });
    }

    isOnAppointmentManagementPage = () => {
        if (window.location.pathname === '/appointment-management/' + this.props.match.params.appointment_id) {
            return true;
        }
        else {
            return false;
        }
    }
    

    loadMessages = () => {
        if (this.isOnAppointmentManagementPage()===true) {
            let url = backendEndpoint + 'appointment/' + this.props.match.params.appointment_id + '/messages/';
            axios.get(url, {
                headers: {'Authorization': 'Token '+ this.props.authToken}
                })
                .then(response => {
                    this.setState({
                        messages: response.data
                    });
                    setTimeout(this.loadMessages, 3 * 1000)
                })
                .catch(err => {
                    Alert.error('failed to load calendar');
                });
        }
    }

    handleLeaveMessage = () => {
        let new_message = this.messageInput.current.value.trim();
        if (new_message){

            let url = backendEndpoint + 'appointment/' + this.props.match.params.appointment_id + '/add_message/';
            let appointmentMessageData = {
                message: new_message,
            }
            axios.post(url, appointmentMessageData, {
                headers: {'Authorization': 'Token '+ this.props.authToken}
                })
                .then(response => {
                    this.setState({
                        messages: [...this.state.messages, {message: new_message, display_name: this.props.myName}]
                    });
                    this.messageInput.current.value = '';
                    // Alert.info('Changes saved');
                })
                .catch(err => {
                    Alert.error('failed to save your changes');
                });

        }
    }

    handleAddToCalendar = () => {
        let url = backendEndpoint + "appointment/" + this.props.match.params.appointment_id + "/calendar_invite/" + this.state.role;
        const response = {
            file: url,
        };
        window.open(response.file);
    }


    render(){

        // let inputSize;
        // if (useMobile()===true) {
        //     inputSize = 'none';
        // }
        // else {
        //     inputSize = 'none';
        // }

        let messages = 'Currently no message yet.';
        if (this.state.messages.length > 0) {
            messages = this.state.messages.map((body, index) => (
                <div className={classes.MessageBody} key={index}>
                <Row>
                    <Col>
                    <Card>
                    <Card.Body>
                        <Card.Title>{body.display_name}</Card.Title>
                        <Card.Text>
                        {body.message}
                        </Card.Text>
                    </Card.Body>
                    </Card>
                    </Col>
                </Row>
                </div>
            ))
        }

        return (

            <div className={classes.AppointmentManagement}>
                <Helmet>
                    <title>Manage Appointment | BookMeeY</title>
                    <meta name="description" content="Manage your BookMeeY appointment" />
                </Helmet>

                <Container>

                

                <Row>
                <Col lg={{span:8, offset:2}}>

                <div className={classes.AppointmentManagementContent}>

                <div className={classes.GoBack}>
                <Row>
                    <Col>
                    <BackTextLink />
                    </Col>
                </Row>
                </div>

                <label><b>Manage My Appointment</b></label>
                <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                    <InputGroup.Text>
                        Host
                    </InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl readOnly value={this.state.host_name}/>
                </InputGroup>
                
                <InputGroup className="mb-3">
                    <InputGroup.Prepend>
                    <InputGroup.Text>
                        Guest
                    </InputGroup.Text>
                    </InputGroup.Prepend>
                    <FormControl readOnly value={this.state.guest_name}/>
                </InputGroup>

                { this.state.contact_method !== null ?
                        <InputGroup className="mb-3">
                        <InputGroup.Prepend>
                            <InputGroup.Text>
                                Contact
                            </InputGroup.Text>
                        </InputGroup.Prepend>
                        <FormControl readOnly value={this.state.contact_method}/>
                        </InputGroup>
                        :
                        null
                }
                
                <InputGroup className="mb-3">
                    <FormControl readOnly value={this.state.time}/>
                </InputGroup>

                <InputGroup>
                    <FormControl 
                        as="textarea" 
                        readOnly
                        aria-label="With textarea"
                        rows="5"
                        value={this.state.details}/>
                </InputGroup>

                <div className={classes.Controls}>
                    <Row>
                        <Col lg={{span:4, offset:4}}>
                        <Button block variant="outline-info" onClick={this.handleAddToCalendar}>Add to Calendar</Button>
                        </Col>
                    </Row>

                </div>

                <div className={classes.MessageBox}>
                    <Row>
                        <Col>
                        <b> Messages </b>
                        </Col>
                    </Row>
                    <div className={classes.Messages}>
                    { messages }
                    </div>
                </div>


                <div className={classes.LeaveMessage}>
                <Form>
                    <Form.Group>
                        <Form.Control ref={this.messageInput} as="textarea" placeholder="Please leave your message" />
                    </Form.Group>
                </Form>
                <Row>
                    <Col lg={{span:4, offset:4}}>
                        <div className={classes.SubmitButton}>
                        <Button block variant='info' onClick={this.handleLeaveMessage}>
                            Leave my message&nbsp;&nbsp;
                            <FontAwesomeIcon icon={faCommentDots}></FontAwesomeIcon>
                        </Button>
                        </div>
                    </Col>
                </Row>
                </div>


                </div>
                {/* This is the end of the Appointment Management unit */}

                </Col>
                </Row>

                </Container>

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        authToken: state.auth.token,
        myName: state.auth.firstName + ' ' + state.auth.lastName
    };
};

export default connect( mapStateToProps ) (AppointmentManagement);


// WEBPACK FOOTER //
// ./src/containers/AppointmentManagement/AppointmentManagement.js